import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/maintenance_mode.svg")